import { createPresignedUploadService } from '@expressable/syntax-ds';
import { api } from 'domains/api';
import { BASE_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';
import { useUserClientsWithActiveClient } from 'domains/auth/UserClientsWrapper/useUserClients';
import { useCallback } from 'react';

/** Creates a reusable function for uploading files with user credentials. This works in two steps
 * 1. Calls BE to create a presigned URL link
 * 2. Uses that link as endpoint to upload the file to
 */
export const usePresignedUploadFunction = () => {
  const { activeClientId, contactId } = useUserClientsWithActiveClient();

  const uploadFn = useCallback(
    createPresignedUploadService({
      uploadClient: api.external,
      urlGenerationClient: api.base,
      urlGenerationEndpoint: getBaseAPIRoute(BASE_API_ROUTES.clients[':clientId']['presigned-url'], {
        contactId,
        clientId: activeClientId,
      }),
    }),
    [contactId, activeClientId],
  );

  return uploadFn;
};
